"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscardOrderRatingNotificationMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class DiscardOrderRatingNotificationMapper {
    toDomain(result) {
        return lodash_1.default.get(result, "data.discardOrderRatingNotification");
    }
}
exports.DiscardOrderRatingNotificationMapper = DiscardOrderRatingNotificationMapper;
